import { Injectable } from '@angular/core';
import {
  AiSolutionUsageDetail,
  AiSolutionUsageDetailBackendResponse,
  AiSolutionUsageStateChangePayload,
} from '@/app/interfaces/ai-solution-usage';
import {
  AiSolutionUsageListBackendResponse,
  AiSolutionUsageListData,
  AiSolutionUsageListParams,
} from '@/app/interfaces/ai-solution-usage-list';
import { LoaderService } from '@/app/services/interceptor/loader-service';
import { environment } from '@/environments/environment';
import axios from 'axios';
import { ToastService } from '../script/toast.service';

@Injectable({
  providedIn: 'root',
})
export class AiSolutionUsageService {
  constructor(
    private toastService: ToastService,
    private loader: LoaderService
  ) {}

  async getAiSolutionUsageList(filters: AiSolutionUsageListParams): Promise<AiSolutionUsageListData> {
    try {
      this.loader.show();
      const response = await axios.post<AiSolutionUsageListBackendResponse>(
        `${environment.url}/api/aurora/listado`,
        { filters: { params: filters }, list: 'solutions' },
        { withCredentials: true }
      );

      return response.data.data;
    } catch (error) {
      const detail = error?.response?.data?.message || 'Ha ocurrido un error inesperado';
      this.toastService.showError('Error al cargar el listado de usos de solución IA', detail);
      throw error;
    } finally {
      this.loader.hide();
    }
  }

  async getAiSolutionUsageDetail(id: string): Promise<AiSolutionUsageDetail> {
    try {
      this.loader.show();
      const response = await axios.post<AiSolutionUsageDetailBackendResponse>(
        `${environment.url}/api/aurora/detalle`,
        { detail: 'solution', id_uso: id },
        { withCredentials: true }
      );

      return response.data.data;
    } catch (error) {
      if (error?.response?.status === 404) {
        this.toastService.showError('Uso de solución IA no encontrado', 'No existe un uso de solución IA con ese id');
        throw error;
      }

      const detail = error?.response?.data?.message || 'Ha ocurrido un error inesperado';
      this.toastService.showError('Error al cargar el detalle de uso de solución IA', detail);
      throw error;
    } finally {
      this.loader.hide();
    }
  }

  async changeAiSolutionUsageState(payload: AiSolutionUsageStateChangePayload): Promise<unknown> {
    try {
      this.loader.show();
      const { data } = await axios.post<{ message?: string }>(
        `${environment.url}/api/aurora/cambio_estado_solucion_IA`,
        payload,
        { withCredentials: true }
      );

      return data;
    } catch (error) {
      const detail = error?.response?.data?.message || 'Ha ocurrido un error inesperado';
      this.toastService.showError('Error al cambiar el estado del uso de solución IA', detail);
      throw error;
    } finally {
      this.loader.hide();
    }
  }
}
